const BASE = process.env.REACT_APP_API_BASE || 'https://us-central1-daycare-39d32.cloudfunctions.net';

async function call(fn, method = 'GET', body = null, params = {}) {
  const url = new URL(`${BASE}/${fn}`);
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') url.searchParams.append(k, v);
  });

  const opts = { method, headers: { 'Content-Type': 'application/json' } };
  if (body) opts.body = JSON.stringify(body);

  const res  = await fetch(url.toString(), opts);
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || `Error ${res.status}`);
  return data;
}

// ── Auth ──────────────────────────────────────────────────────────────────────
export const authApi = {
  register:  (d)           => call('register',   'POST', d),
  login:     (d)           => call('login',      'POST', d),
  sendOtp:               (phone)       => call('send_otp',                  'POST', { phone }),
  verifyOtp:             (phone, otp)  => call('verify_otp',                'POST', { phone, otp }),
  initiateWhatsappSignup:(phone)       => call('initiate_whatsapp_signup',   'POST', { phone }),
};

// ── Schools ───────────────────────────────────────────────────────────────────
export const schoolsApi = {
  getAll:      (status = 'active') => call('get_schools', 'GET', null, { status }),
  getOne:      (schoolId)          => call('get_school',  'GET', null, { schoolId }),
  create:      (d)                 => call('create_school', 'POST', d),
  update:      (d)                 => call('update_school', 'PUT',  d),
  remove:      (schoolId, adminId) => call('delete_school', 'DELETE', { schoolId, adminId }),
  uploadImage: (d)                 => call('upload_school_image', 'POST', d),
};

// ── Bookings ──────────────────────────────────────────────────────────────────
export const bookingsApi = {
  create:       (d)      => call('create_booking',       'POST', d),
  getAll:       (params) => call('get_bookings',          'GET',  null, params),
  updateStatus: (d)      => call('update_booking_status', 'PUT',  d),
  cancel:       (d)      => call('cancel_booking',        'PUT',  d),
};

// ── Notifications ─────────────────────────────────────────────────────────────
export const notifApi = {
  getAll:    (userId) => call('get_notifications',    'GET', null, { userId }),
  markRead:  (d)      => call('mark_notification_read', 'PUT', d),
};

// ── Admin ─────────────────────────────────────────────────────────────────────
export const adminApi = {
  getUsers:    (adminId) => call('get_all_users',       'GET',  null, { adminId }),
  getStats:    (params)  => call('get_dashboard_stats', 'GET',  null, params),
  createUser:  (d)       => call('admin_create_user',   'POST', d),
  updateUser:  (d)       => call('admin_update_user',   'PUT',  d),
  deleteUser:  (d)       => call('delete_user',         'DELETE', d),
};

// ── Settings ──────────────────────────────────────────────────────────────────
export const settingsApi = {
  get:  (adminId) => call('get_settings',  'GET',  null, { adminId }),
  save: (d)       => call('save_settings', 'POST', d),
};

// ── Events ────────────────────────────────────────────────────────────────────
export const eventsApi = {
  create:      (d)        => call('create_event',       'POST',   d),
  uploadImage: (d)        => call('upload_event_image', 'POST',   d),
  update:      (d)        => call('update_event',       'POST',   d),
  getAll:      (params)   => call('get_events',         'GET',    null, params),
  getPublic:   (schoolId) => call('get_public_events',  'GET',    null, { schoolId }),
  getOne:      (eventId)  => call('get_event',          'GET',    null, { eventId }),
  remove:      (d)        => call('delete_event',       'DELETE', d),
  downloadUrl: (url, filename) => `${BASE}/download_image?url=${encodeURIComponent(url)}&filename=${encodeURIComponent(filename)}`,
};
